import { createFileRoute, redirect } from "@tanstack/react-router";
import { formBuilderSearchSchema } from "@/features/forms/components/form-builder/formBuilderSearch";

/** Each builder step has its own URL; the bare form URL opens Questions. */
export const Route = createFileRoute("/_app/builder/forms/$formId/")({
    validateSearch: (search) => formBuilderSearchSchema.parse(search),
    beforeLoad: ({ params, search }) => {
        throw redirect({
            to: "/builder/forms/$formId/$tab",
            params: { formId: params.formId, tab: "questions" },
            search,
            replace: true,
        });
    },
});
